import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BOPerson } from '../../models/BOPerson.model';
import { BOClinicHistory } from '../../models/BOClinicHistory.model';
import { FormBuilder } from '@angular/forms';
import { Utilities } from '../../common/utilities';

@Component({
  selector: 'app-ch-control',
  templateUrl: './ch-control.component.html',
  styleUrls: ['./ch-control.component.css']
})
export class ChControlComponent implements OnInit {

      @Input() id!: number;
      @Input() clinicHistoryId!:number;
      @Input() patient!: BOPerson;
      @Input() controlNumber!: number;
      @Input() posInArray!:number;
      @Input() professionalId!: number;
      @Input() controlDate!: Date;
      @Input() details!: string;
      @Input() professionalList:BOPerson[]; //professionalShortList en COUCH

     @Output() posSendedId = new EventEmitter<{ itemId: number }>(); // ← Cambia el tipo
     patientNameChoosed="";
     professionalChoosed="";

    //  professionalByAreaList: BOPerson[];
    //  person: BOPerson= new BOPerson();

  constructor(private _formBuilder: FormBuilder) { }

      chControlFormGroup=this._formBuilder.group({
        posInArray      :{ value: null, disabled: true },
        clinicHistoryId :{ value: null, disabled: true },
        controlNumber   :{ value: null, disabled: true },
        patientName     :{ value: null, disabled: true },
        professionalName:{ value: null, disabled: true },
        controlDate     :{ value: null, disabled: true },
        details         :{ value: null}
      })
  ngOnInit(): void
  {
    this.patientNameChoosed= Utilities.getNameFromPerson(this.patient);
    this.professionalChoosed=Utilities.getProfesionalName(this.professionalId, this.professionalList);
    const formattedControlDate = this.formatToDDMMYYYY(this.controlDate);
    //console.log("EN ngOnInit de CHCONTROLCOMPONENTE, controlDate es:", this.controlDate)
     this.chControlFormGroup.patchValue({
       clinicHistoryId :this.clinicHistoryId,
       patientName: this.patientNameChoosed,
       professionalName:this.professionalChoosed,
       controlNumber: this.controlNumber,
       controlDate:formattedControlDate,
       details:this.details,
       posInArray: this.posInArray +1,
    //     // patientName: Utilities.getNameFromPerson(this.patient),
    //     // professionalName: Utilities.getProfesionalName(this.professionalId, this.professionalList),


     })

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.chControlFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }

  deleteItemSingle(): void {
    this.posSendedId.emit({ itemId: this.id }); // ← Emite ID, no posición
  }

  private formatToDDMMYYYY(dateInput: string | Date | null): string {
    if (!dateInput) return '';

    const date = new Date(dateInput);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
}

}
